export default {"src":"/_next/static/media/icon_earn_tier.0d4d41f9.svg","height":24,"width":33,"blurWidth":0,"blurHeight":0};